/**
 * @fileoverview gRPC-Web generated client stub for acompanha.subscription_plans.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/subscription_plans/v1/subscription_plans.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.subscription_plans = {};
proto.acompanha.subscription_plans.v1 = require('./subscription_plans_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest,
 *   !proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse>}
 */
const methodDescriptor_SubscriptionPlansService_ListSubscriptionPlans = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_plans.v1.SubscriptionPlansService/ListSubscriptionPlans',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest,
  proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse,
  /**
   * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServiceClient.prototype.listSubscriptionPlans =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/ListSubscriptionPlans',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_ListSubscriptionPlans,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServicePromiseClient.prototype.listSubscriptionPlans =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/ListSubscriptionPlans',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_ListSubscriptionPlans);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest,
 *   !proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse>}
 */
const methodDescriptor_SubscriptionPlansService_GetSubscriptionPlan = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_plans.v1.SubscriptionPlansService/GetSubscriptionPlan',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest,
  proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse,
  /**
   * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServiceClient.prototype.getSubscriptionPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/GetSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_GetSubscriptionPlan,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServicePromiseClient.prototype.getSubscriptionPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/GetSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_GetSubscriptionPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest,
 *   !proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse>}
 */
const methodDescriptor_SubscriptionPlansService_CreateSubscriptionPlan = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_plans.v1.SubscriptionPlansService/CreateSubscriptionPlan',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest,
  proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse,
  /**
   * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServiceClient.prototype.createSubscriptionPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/CreateSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_CreateSubscriptionPlan,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServicePromiseClient.prototype.createSubscriptionPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/CreateSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_CreateSubscriptionPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest,
 *   !proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse>}
 */
const methodDescriptor_SubscriptionPlansService_UpdateSubscriptionPlan = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_plans.v1.SubscriptionPlansService/UpdateSubscriptionPlan',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest,
  proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse,
  /**
   * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServiceClient.prototype.updateSubscriptionPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/UpdateSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_UpdateSubscriptionPlan,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServicePromiseClient.prototype.updateSubscriptionPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/UpdateSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_UpdateSubscriptionPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_SubscriptionPlansService_DeleteSubscriptionPlan = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_plans.v1.SubscriptionPlansService/DeleteSubscriptionPlan',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServiceClient.prototype.deleteSubscriptionPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/DeleteSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_DeleteSubscriptionPlan,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlansServicePromiseClient.prototype.deleteSubscriptionPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_plans.v1.SubscriptionPlansService/DeleteSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_SubscriptionPlansService_DeleteSubscriptionPlan);
};


module.exports = proto.acompanha.subscription_plans.v1;

